export default __webpack_public_path__ + "static/media/hp_slide2.b8c29c67.jpg";